const map = {
	"./menuElakay_en.json": [
		58126,
		[]
	],
	"./menuElakay_es.json": [
		65285,
		[
			285
		]
	],
	"./menuElakay_fr.json": [
		13165,
		[
			165
		]
	],
	"./menuElakay_ht.json": [
		71141,
		[
			141
		]
	],
	"./menuElakay_pt.json": [
		35661,
		[
			661
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 26659;
module.exports = webpackAsyncContext;